import "./App.css";
import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ContactPage from "./components/ContactPage";
import GalleryPage from "./components/GalleryPage";
import BlogPage from "./components/BlogPage";
import ServicesPage from "./components/ServicesPage";
import AboutPage from "./components/AboutPage";
import ProjectsPage from "./components/ProjectsPage";
import TemplateLeftSidebar from "./components/TemplateLeftSidebar";
import TemplateRightSidebar from "./components/TemplateRightSidebar";
import TemplateFullWidth from "./components/TemplateFullWidth";
import TemplateNoSidebar from "./components/TemplateNoSidebar";
import TemplateGridLayout from "./components/TemplateGridLayout";
import GameDetailPage from "./components/GameDetailPage";
import NewsDetailPage from "./components/NewsDetailPage";
import FocusDetailPage from "./components/FocusDetailPage";
import ServiceDetailPage from "./components/ServiceDetailPage";
import SportsMeditationPage from "./components/SportsMeditationPage";
import SportsPage from "./components/SportsPage";
import { motion } from "framer-motion";
import { games } from "./index";
import logo from "./assets/bg-remover-logo.png";
import heroImage1 from "./assets/image1carosel.jpeg";
import heroImage2 from "./assets/heroImage2.jpeg";
import heroImage3 from "./assets/heroImage3.jpeg";
import { CoachesPage } from "./components/Coaches";
import CourtsPage from "./components/courtsPage";
import monikaImage from "./assets/IMG-20251107-WA0119.jpg";
import piyushPariharImage from "./assets/piyushPariarImage.jpg";
// coaches data
export const coachesData = [
  {
    name: "Chitra",
    role: "Sports Phychologist CEO & Director",
    image: "./assets/Chitra.jpg",
    description:
      "CEO and Director of Ask Me Sports Allianz Qualified Psychologist of Sports experience of dealing with sports person to develop the mind set and over come the challenges.",
    achievements: [
      "10+ years of experience in sports leadership",
      "Former national-level athlete",
      "Certified international coach",
      "Led multiple championship-winning teams",
    ],
  },
  {
    name: "Piyush",
    role: "Badminton Coach & Sports Psychologist",
    image: piyushPariharImage,
    description:
      "I am Director Chief Badminton Coach and Sports Psychologist of Ask Me Sports Allianz. I am also member of Rajasthan Badminton Association. I am senior management & Coach positions in Rajasthan  Sport Association.I was Head of Sports Strategy, Sports Recruitment & Development of Sports in Government and was part of the executive team to transform the sports  to an international level. I was professional Badminton player, who played in UK for 2 years as professional badminton and was also the participated in London Open, Along with many international tournaments & Circuit championship. I also holds the back ground of international badminton coach with coaching ability and coaching experience in countries like China, & Mauritius. With new contract coming for Malaysia. ",
    achievements: [
      "S BWF certified Level- 1 Coach",
      "Only Coach in Rajasthan to do Advance Coaches Program conducted by Badminton Association of India in 2024",
      // "Certified wellness & fitness coach",
      // "Conducted multiple national-level workshops",
    ],
  },
  {
    name: "Praachal",
    role: "Sports Meditation Expert",
    image: "./assets/Praachal.jpg",
    description:
      "Expert and experience in Sports Meditation.  Which seems to be new and advance version of Meditation which is developed and crafted for sports persons to achieve their SMARTER Goals and define the Goal setting to Podium finish.",
    achievements: [
      "Expert in sports mindfulness & yoga",
      "Trained 100+ athletes in meditation",
      "Certified wellness & fitness coach",
      "Conducted multiple national-level workshops",
    ],
  },
  {
    name: "Ankit Kumar Manawat",
    role: "Physical Fitness Trainner",
    image: "./assets/Ankit-Kumar-Manawat.jpg",
    description:
      "Ankit Kumar Manawat is a passionate squash trainer who believes in building agility, reflex, and smart play strategies for his students.",
    achievements: [
      "National Squash Championship participant",
      "10+ years experience",
      "Focus on youth development programs",
      "Certified professional trainer",
    ],
  },
  {
    name: "Zahir Taj",
    role: "Women’s Cricket Coach",
    image: "./assets/Zahir-Taj.jpg",
    description:
      "Zahir Taj is dedicated to empowering women in cricket, providing high-level training in batting, bowling, and match strategy.",
    achievements: [
      "Former professional cricketer",
      "10+ years of cricket coaching",
      "Trained state and national women players",
      "Specialist in performance analysis",
    ],
  },
  {
    name: "Shikha Dhall",
    role: "Rifle Shooting Coach",
    image: "./assets/Shikha-Dhall.jpg",
    description:
      "Shikha Dhall is a Rifle Shooting expert, training athletes with a balance of precision, calm, and control to improve accuracy and focus.",
    achievements: [
      "Former national-level shooter",
      "Certified rifle coach",
      "19 years experience",
      "Mentored multiple medal winners",
      "Focus on psychological training",
    ],
  },
  {
    name: "Riyaz Ahmed",
    role: "Tennis Coach",
    image: "./assets/Riyaz-Ahmed.jpg",
    description:
      "Riyaz is an experienced Tennis coach known for technical excellence and personalized mentoring that helps players enhance match performance.",
    achievements: [
      "Trained 50+ competitive players",
      "InterNational-level Tennis player",
      "Certified Lawn Tennis Coach",
      "Works with junior national academy",
    ],
  },
  {
    name: "Mohit Verma",
    role: "Table Tennis Coach",
    image: "./assets/Mohit-Verma.jpg",
    description:
      "International table tennis player Reprsented India 14 Times in diffrent age groups Indian Senior Open 2010- Participation Taiwan Open Gold Medalist-2009 Childerns of Asia Games(Russia) bronze medalist-2008 9 times Senior national medalist in teams and doubles from 2012 to 2018. National games medalist-2011 5 times Haryana state Champion.",
    achievements: [
      "7+ years of professional experience",
      "Represented state in multiple tournaments",
      "Trained 150+ students",
      "Focus on modern TT techniques",
      "10+ coaching experience",
    ],
  },
  {
    name: "Monika",
    role: "Weightlifting Coach",
    image: monikaImage,
    description:
      "Monika is a certified weightlifting coach dedicated to building strength, precision, and endurance in every athlete. Her training focuses on perfecting lifting techniques, improving stability, and helping athletes reach their peak performance safely and effectively.",
    achievements: [
      "9 times National champion",
      "7 times inter railways medalist ",
      "06 years coaching experience",
      "* Represent country in CWC as a coach",
    ],
  },
  {
    name: "Mala Sukhwal",
    role: "Powerlifting Coach",
    image: "./assets/Mala Sukhwal.jpg",
    description:
      "Mala Sukhwal is an accomplished powerlifting coach known for her result-driven training and focus on strength and endurance development. Selected as A coach of Women Team of Indian Railway 2020 to till 2024 & always got championship 🏆 State Award By CM of Rajasthan ( Maharana Pratap Award)2008Experience - 2003 to till now, 22 years Powerlifting experience & also Yoga, Meditation",
    achievements: [
      "5+ years of experience in strength coaching",
      "Silver medal in all India Inter university Powerlifting tournament 2006 At Gwalior",
      "InterNational-level powerlifter",
      "Certified powerlifting instructor",
      "Mentored several national champions",
    ],
  },
  {
    name: "Akshay Kalosia",
    role: "Boxing Coach",
    image: "./assets/akshay-kalosia.jpg",
    description:
      "Akshay is a professional boxing coach with deep technical knowledge and a strong focus on discipline, defense, and power techniques.",
    achievements: [
      "Professional boxer turned coach",
      "Trained over 200 students",
      "Multiple district-level medals",
      "certified : BFI national refree & judge & Coach",
      "Certified by National Boxing Association",
    ],
  },
  {
    name: "Hitesh Deshwal",
    role: "Athletics Coach",
    image: "./assets/Hitesh-Deshwal.jpg",
    description:
      "Hitesh brings immense expertise in athletics, focusing on sprint, long jump, and endurance training to help athletes reach peak performance.",
    achievements: [
      "8+ years in athletics coaching",
      "Specialist in sprint and field events",
      "06 years coaching experience",
      "Worked with state-level athletes",
      "NIS Certified Athletics Coach",
    ],
  },
];

// Global Header Component with proper active state management
function GlobalHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeHomeSection, setActiveHomeSection] = useState("home");
  const [pendingScrollSection, setPendingScrollSection] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Handle resize to close mobile menu on desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobileMenuOpen]);

  // Listen for scroll to update active section on homepage
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === "/") {
        const sections = [
          "home",
          "about",
          "services",
          "coaches",
          "results",
          "news",
        ];
        const scrollPosition = window.scrollY + 100;

        for (let i = sections.length - 1; i >= 0; i--) {
          const section = document.getElementById(sections[i]);
          if (section && section.offsetTop <= scrollPosition) {
            setActiveHomeSection(sections[i]);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  // Handle pending scroll section after navigation
  useEffect(() => {
    if (location.pathname === "/" && pendingScrollSection) {
      const element = document.getElementById(pendingScrollSection);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          setActiveHomeSection(pendingScrollSection);
          setPendingScrollSection(null);
        }, 100);
      }
    }
  }, [location.pathname, pendingScrollSection]);

  const isActive = (path, section = null) => {
    // For other pages (contact, gallery, blog)
    if (path !== "/") {
      return location.pathname === path;
    }

    // For homepage sections
    if (path === "/" && location.pathname === "/") {
      if (section) {
        return activeHomeSection === section;
      }
      return activeHomeSection === "home";
    }

    return false;
  };

  const handleHomeNavClick = (e, sectionId) => {
    e.preventDefault();
    closeMobileMenu();

    // If HOME button is clicked, always navigate to home page
    if (sectionId === "home") {
      navigate("/");
      return;
    }

    // For other sections (about, services, coaches)
    if (location.pathname === "/") {
      // If already on home page, scroll to section
      setActiveHomeSection(sectionId);
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else {
      // If not on home page, navigate to home page and set pending scroll
      setPendingScrollSection(sectionId);
      navigate("/");
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img
              src={logo}
              alt="Sports Infrastructure Solutions Logo"
              className="logo-icon"
            />
            <span onClick={() => navigate("/")} className="logo-text">
              ASK ME SPORTS ALLIANCE
            </span>
          </div>
          <nav className={`navigation ${isMobileMenuOpen ? "active" : ""}`}>
            <Link
              to="/"
              className={`nav-link ${isActive("/", "home") ? "active" : ""}`}
              onClick={(e) => handleHomeNavClick(e, "home")}
            >
              HOME
            </Link>

            <Link
              to="/about"
              className={`nav-link ${isActive("/about") ? "active" : ""}`}
              onClick={closeMobileMenu}
            >
              ABOUT
            </Link>

            {/* 🏅 SPORTS DROPDOWN */}
            <div className="nav-dropdown">
              <Link
                to="/sports-meditation"
                className={`nav-link ${
                  isActive("/sports-meditation") ? "active" : ""
                }`}
                onClick={closeMobileMenu}
              >
                SPORTS
              </Link>

              <div className="dropdown-menu">
                <Link to="/badminton" className="dropdown-item">
                  Badminton
                </Link>
                <Link to="/sports-meditation" className="dropdown-item">
                  Sports Meditation
                </Link>
                <Link to="/service/physiology" className="dropdown-item">
                  Sports Physiologist
                </Link>
                <Link to="/sports-fitness" className="dropdown-item">
                  Sports Fitness
                </Link>
                <Link to="/cricket-women" className="dropdown-item">
                  Cricket (Women)
                </Link>
                <Link to="/shooting" className="dropdown-item">
                  Shooting
                </Link>
                <Link to="/tennis" className="dropdown-item">
                  Tennis
                </Link>
                <Link to="/table-tennis" className="dropdown-item">
                  Table Tennis
                </Link>
                <Link to="/weightlifting" className="dropdown-item">
                  Weightlifting
                </Link>
                {/* <Link to="/volleyball" className="dropdown-item">Volleyball</Link> */}
                <Link to="/powerlifting" className="dropdown-item">
                  Powerlifting
                </Link>
                <Link to="/boxing" className="dropdown-item">
                  Boxing
                </Link>
                <Link to="/athletes" className="dropdown-item">
                  Athletes
                </Link>
                {/* 👇 “Sports Infrastructure Developer” removed from here */}
              </div>
            </div>

            <Link
              to="/services"
              className={`nav-link ${isActive("/services") ? "active" : ""}`}
              onClick={closeMobileMenu}
            >
              SERVICES
            </Link>
            {/* 🏗️ Independent Nav Link for Sports Infrastructure */}
            <Link
              to="/sports-infrastructure"
              className={`nav-link ${
                isActive("/sports-infrastructure") ? "active" : ""
              }`}
              onClick={closeMobileMenu}
            >
              SPORTS INFRASTRUCTURE
            </Link>

            <Link
              to="/projects"
              className={`nav-link ${isActive("/projects") ? "active" : ""}`}
              onClick={closeMobileMenu}
            >
              PROJECTS
            </Link>

            <Link
              to="/"
              className={`nav-link ${isActive("/", "coaches") ? "active" : ""}`}
              onClick={(e) => handleHomeNavClick(e, "coaches")}
            >
              COACHES
            </Link>

            <Link
              to="/gallery"
              className={`nav-link ${isActive("/gallery") ? "active" : ""}`}
              onClick={closeMobileMenu}
            >
              GALLERY
            </Link>

            <Link
              to="/contact"
              className={`nav-link ${isActive("/contact") ? "active" : ""}`}
              onClick={closeMobileMenu}
            >
              CONTACT US
            </Link>
          </nav>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeSection, setActiveSection] = useState("home");
  const totalSlides = 3;

  const changeSlide = (direction) => {
    setCurrentSlide((prev) => {
      if (direction === 1) {
        return prev === totalSlides - 1 ? 0 : prev + 1;
      } else {
        return prev === 0 ? totalSlides - 1 : prev - 1;
      }
    });
  };

  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  // Update active slide class
  useEffect(() => {
    const slides = document.querySelectorAll(".carousel-slide");
    const indicators = document.querySelectorAll(".indicator");

    slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === currentSlide);
    });

    indicators.forEach((indicator, index) => {
      indicator.classList.toggle("active", index === currentSlide);
    });
  }, [currentSlide]);

  // Scroll listener to update active section
  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "services", "coaches", "contact"];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <Router>
      {/* ✅ Floating WhatsApp Button */}
      <a
        href="https://wa.me/9414050348"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>

      <GlobalHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route
          path="/template-left-sidebar"
          element={<TemplateLeftSidebar />}
        />
        <Route
          path="/template-right-sidebar"
          element={<TemplateRightSidebar />}
        />
        <Route path="/template-full-width" element={<TemplateFullWidth />} />
        <Route path="/template-no-sidebar" element={<TemplateNoSidebar />} />
        <Route path="/template-grid-layout" element={<TemplateGridLayout />} />
        <Route path="/game/:gameId" element={<GameDetailPage />} />
        <Route path="/news/:newsId" element={<NewsDetailPage />} />
        <Route path="/focus/:focusId" element={<FocusDetailPage />} />
        <Route path="/service/:serviceId" element={<ServiceDetailPage />} />
        <Route path="/sports-meditation" element={<SportsMeditationPage />} />
        <Route path="/sports-fitness" element={<SportsPage />} />
        <Route path="/badminton" element={<SportsPage />} />
        <Route path="/table-tennis" element={<SportsPage />} />
        <Route path="/athletes" element={<SportsPage />} />
        <Route path="/boxing" element={<SportsPage />} />
        <Route path="/shooting" element={<SportsPage />} />
        <Route path="/weightlifting" element={<SportsPage />} />
        <Route path="/cricket-women" element={<SportsPage />} />
        <Route path="/tennis" element={<SportsPage />} />
        <Route path="/volleyball" element={<SportsPage />} />
        <Route path="/powerlifting" element={<SportsPage />} />
        <Route path="/sports-infrastructure" element={<SportsPage />} />
        <Route path="/coaches/:name" element={<CoachesPage />} />
        <Route path="/courts/:name" element={<CourtsPage />} />
      </Routes>
    </Router>
  );
}

function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isVideoMinimized, setIsVideoMinimized] = useState(false);
  const [isVideoFullscreen, setIsVideoFullscreen] = useState(false);
  const [videoPosition, setVideoPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const totalSlides = 3;

  const navigate = useNavigate();

  const changeSlide = (direction) => {
    setCurrentSlide((prev) => {
      if (direction === 1) {
        return prev === totalSlides - 1 ? 0 : prev + 1;
      } else {
        return prev === 0 ? totalSlides - 1 : prev - 1;
      }
    });
  };

  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };

  const handleWatchVideo = () => {
    setIsVideoOpen(true);
    setIsVideoMinimized(false);

    // Center the video on screen
    const centerX =
      (window.innerWidth - Math.min(800, window.innerWidth * 0.9)) / 2;
    const centerY =
      (window.innerHeight - Math.min(500, window.innerHeight * 0.7)) / 2;
    setVideoPosition({ x: centerX, y: centerY });

    // Auto fullscreen on first open
    setTimeout(() => {
      enterFullscreen();
    }, 100);
  };

  const closeVideo = () => {
    // Exit fullscreen first
    if (isVideoFullscreen) {
      exitFullscreen();
    }

    // Stop any ongoing drag
    setIsDragging(false);

    // Reset all states
    setIsVideoOpen(false);
    setIsVideoMinimized(false);
    setIsVideoFullscreen(false);
    setVideoPosition({ x: 0, y: 0 });
    setDragOffset({ x: 0, y: 0 });

    // Clean up any event listeners
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    document.body.style.userSelect = "";
  };

  const minimizeVideo = () => {
    setIsVideoMinimized(true);
    setIsVideoFullscreen(false);
    // Position minimized video in top-right corner
    setVideoPosition({
      x: window.innerWidth - 320,
      y: 20,
    });
  };

  const maximizeVideo = () => {
    setIsVideoMinimized(false);
    // Center the video when maximizing
    const centerX =
      (window.innerWidth - Math.min(800, window.innerWidth * 0.9)) / 2;
    const centerY =
      (window.innerHeight - Math.min(500, window.innerHeight * 0.7)) / 2;
    setVideoPosition({ x: centerX, y: centerY });
  };

  // Fullscreen functionality
  const enterFullscreen = () => {
    const videoModal = document.querySelector(".video-modal");
    if (videoModal && !isVideoFullscreen) {
      try {
        if (videoModal.requestFullscreen) {
          videoModal.requestFullscreen();
        } else if (videoModal.webkitRequestFullscreen) {
          videoModal.webkitRequestFullscreen();
        } else if (videoModal.msRequestFullscreen) {
          videoModal.msRequestFullscreen();
        }
        setIsVideoFullscreen(true);
      } catch (error) {
        console.warn("Fullscreen request failed:", error);
      }
    }
  };

  const exitFullscreen = () => {
    if (isVideoFullscreen) {
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        setIsVideoFullscreen(false);
      } catch (error) {
        console.warn("Exit fullscreen failed:", error);
        setIsVideoFullscreen(false);
      }
    }
  };

  const toggleFullscreen = () => {
    if (isVideoFullscreen) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  };

  // Handle fullscreen change events
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
      setIsVideoFullscreen(isFullscreen);
    };

    if (isVideoOpen) {
      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.addEventListener("msfullscreenchange", handleFullscreenChange);
    }

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, [isVideoOpen]);

  // Drag functionality
  const handleDragStart = (e) => {
    if (e.target.closest(".control-btn")) return; // Don't drag if clicking control buttons

    setIsDragging(true);
    const modal = e.currentTarget.closest(".video-modal");
    const rect = modal.getBoundingClientRect();

    // Calculate offset from mouse to modal's top-left corner
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
    e.preventDefault();
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;

    // Calculate new position based on mouse position minus the offset
    const newX = e.clientX - dragOffset.x;
    const newY = e.clientY - dragOffset.y;

    // Get actual modal dimensions
    const modalWidth = isVideoMinimized
      ? 300
      : Math.min(800, window.innerWidth * 0.9);
    const modalHeight = isVideoMinimized
      ? 200
      : Math.min(500, window.innerHeight * 0.7);

    // Keep video within viewport bounds
    const maxX = window.innerWidth - modalWidth;
    const maxY = window.innerHeight - modalHeight;

    setVideoPosition({
      x: Math.max(0, Math.min(newX, maxX)),
      y: Math.max(0, Math.min(newY, maxY)),
    });
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  // Add global mouse event listeners for dragging
  useEffect(() => {
    if (isDragging && isVideoOpen) {
      const handleMouseMove = (e) => handleDragMove(e);
      const handleMouseUp = () => handleDragEnd();

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.userSelect = "none"; // Prevent text selection while dragging

      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.body.style.userSelect = "";
      };
    }
  }, [isDragging, dragOffset, isVideoMinimized, isVideoOpen]);

  // Handle mouse movement for parallax effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };

    if (isVideoOpen) {
      window.addEventListener("mousemove", handleMouseMove);
    }

    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [isVideoOpen]);

  // Initialize animations on load
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 6000); // Change slide every 6 seconds

    return () => clearInterval(interval);
  }, []);

  // Update active slide class
  useEffect(() => {
    const slides = document.querySelectorAll(".carousel-slide");
    const indicators = document.querySelectorAll(".indicator");

    slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === currentSlide);
    });

    indicators.forEach((indicator, index) => {
      indicator.classList.toggle("active", index === currentSlide);
    });
  }, [currentSlide]);

  const handleCoachesClick = (name) => {
    const formattedName = name.replace(/\s+/g, "-"); // URL-friendly name
    navigate(`/coaches/${formattedName}`); // navigate to detail page
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="home-page">
      {/* Animated Background Elements */}
      <div className="animated-bg">
        <div className="floating-shapes">
          <div
            className="shape shape-1"
            style={{
              transform: `translate(${mousePosition.x * 0.02}px, ${
                mousePosition.y * 0.02
              }px)`,
            }}
          ></div>
          <div
            className="shape shape-2"
            style={{
              transform: `translate(${mousePosition.x * -0.03}px, ${
                mousePosition.y * -0.03
              }px)`,
            }}
          ></div>
          <div
            className="shape shape-3"
            style={{
              transform: `translate(${mousePosition.x * 0.01}px, ${
                mousePosition.y * 0.04
              }px)`,
            }}
          ></div>
        </div>
      </div>

      {/* Hero Section */}
      <section id="home" className={`hero ${isLoaded ? "loaded" : ""}`}>
        <div className="hero-carousel">
          <div
            className="carousel-slide active"
            style={{
              backgroundImage: `url(${heroImage1})`, // ✅ fixed            backgroundSize: 'cover',
              backgroundPosition: "center",
              transform: `translateX(${mousePosition.x * 0.01}px) translateY(${
                mousePosition.y * 0.01
              }px)`,
            }}
          >
            <div className="hero-overlay"></div>
          </div>
          <div
            className="carousel-slide"
            style={{
              backgroundImage: `url(${heroImage2})`, // ✅ fixed            backgroundSize: 'cover',
              backgroundSize: "cover",
              backgroundPosition: "center",
              transform: `translateX(${mousePosition.x * 0.01}px) translateY(${
                mousePosition.y * 0.01
              }px)`,
            }}
          >
            <div className="hero-overlay"></div>
          </div>
          <div
            className="carousel-slide"
            style={{
              backgroundImage: `url(${heroImage3})`, // ✅ fixed            backgroundSize: 'cover',
              backgroundSize: "cover",
              backgroundPosition: "center",
              transform: `translateX(${mousePosition.x * 0.01}px) translateY(${
                mousePosition.y * 0.01
              }px)`,
            }}
          >
            <div className="hero-overlay"></div>
          </div>
        </div>

        <div className="container">
          <div className="hero-content">
            <div className={`hero-badge ${isLoaded ? "animate" : ""}`}>
              <span>🏆 A To Z Sports Solutions</span>
            </div>
            <h1 className={`hero-title ${isLoaded ? "animate" : ""}`}>
              <span className="title-line">BECOME A PART OF</span>
              <span className="title-line accent">SPORTS TEAM</span>
              <span className="title-line">COMMUNITY</span>
            </h1>
            <p className={`hero-subtitle ${isLoaded ? "animate" : ""}`}>
              Connect, Compete, Celebrate
            </p>
            <p className={`hero-description ${isLoaded ? "animate" : ""}`}>
              Join our comprehensive sports community where athletes connect,
              compete, and celebrate their podium achievements. We provide
              world- class scientific training, coaching, and development
              programs for athletes of all skill levels.
            </p>
            <div className={`hero-buttons ${isLoaded ? "animate" : ""}`}>
              <button
                className="btn btn-primary"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/askmesportsalliance",
                    "_blank"
                  )
                }
              >
                <span>Join Community</span>
                <div className="btn-ripple"></div>
              </button>
              <button
                className="btn watch-video btn-secondary"
                onClick={handleWatchVideo}
              >
                <span>Watch Video</span>
                <div className="play-icon">▶</div>
              </button>
            </div>
          </div>
        </div>

        <div className="hero-navigation">
          <button className="nav-arrow left" onClick={() => changeSlide(-1)}>
            <span>‹</span>
          </button>
          <button className="nav-arrow right" onClick={() => changeSlide(1)}>
            <span>›</span>
          </button>
        </div>

        <div className="carousel-indicators">
          <span
            className="indicator active"
            onClick={() => goToSlide(0)}
          ></span>
          <span className="indicator" onClick={() => goToSlide(1)}></span>
          <span className="indicator" onClick={() => goToSlide(2)}></span>
        </div>

        {/* Scroll indicator */}
        <div className="scroll-indicator">
          <div className="scroll-text">Scroll Down</div>
          <div className="scroll-arrow">
            <div className="arrow-line"></div>
            <div className="arrow-line"></div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="two-column-layout">
            <div className="about-image">
              <img
                src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFkbWludG9ufGVufDB8fDB8fHww&fm=jpg&q=60&w=3000"
                alt="Sports players in action"
                className="sports-image"
              />
            </div>
            <div className="about-content">
              <h2 className="section-title">
                About <span className="accent-text">Sports Alliance</span>
              </h2>
              <div className="title-underline"></div>
              <p className="about-description">
                We are a premier sports consultancy dedicated to nurturing
                athlete talent and empowering future champions. Our mission is
                to deliver world-class and scientific training programs that
                help athletes unlock their full potential and achieve greatness.
                With expert coaches and advanced training program, we provide
                the ideal environment for growth, discipline, and excellence. At
                Sports Alliance, we don’t just train athletes — we build future
                champions to achieve their goals.
              </p>
              <p className="about-description">
                Our experienced coaches and state-of-the-art advance coaching
                program create the perfect environment for over all athlete
                development. We focus on building character, discipline, mental
                toughness and excellence in every athlete we train.
              </p>
              {/* <div className="progress-bars">
                <div className="progress-item">
                  <div className="progress-label">FITNESS <span className="percentage">(95%)</span></div>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '95%' }}></div>
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-label">GAME PLAN <span className="percentage">(65%)</span></div>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '65%' }}></div>
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-label">STRATEGY <span className="percentage">(75%)</span></div>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '75%' }}></div>
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-label">PASSION <span className="percentage">(85%)</span></div>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '85%' }}></div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Games Section */}
      <section className="games-section">
        <div className="container">
          <h2 className="section-title">
            Our <span className="accent-text">Key Areas</span>
          </h2>
          <div className="title-underline"></div>
          <p className="section-description">
            Scientific training and Professional coaching for various sports
            disciplines with expert guidance.
          </p>
          {/* Game Cards */}

          <motion.div
            className="games-grid-all"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.15, // ek ek karke cards aayein
                },
              },
            }}
          >
            {games.map((game, index) => (
              <motion.div
                key={index}
                className="game-card"
                variants={{
                  hidden: { opacity: 0, y: 60, scale: 0.95 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    transition: {
                      duration: 0.7,
                      ease: [0.25, 0.1, 0.25, 1], // smooth bezier curve
                    },
                  },
                }}
                whileHover={{
                  y: -8,
                  scale: 1.04,
                  boxShadow: "0px 12px 25px rgba(0,0,0,0.2)",
                }}
                whileTap={{ scale: 0.98 }}
              >
                <motion.div
                  className="overflow-hidden rounded-xl"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.4 }}
                >
                  <motion.img
                    src={game.image}
                    alt={game.title}
                    className="game-image"
                    initial={{ scale: 1 }}
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 0.4 }}
                  />
                </motion.div>
                <motion.h3
                  className="game-title"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1, duration: 0.4 }}
                >
                  {game.title}
                </motion.h3>
                <motion.p
                  className="game-description"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.4 }}
                >
                  {game.description}
                </motion.p>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <Link to={game.link} className="game-btn">
                    LEARN MORE
                  </Link>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Focus Areas Section */}
      <section className="focus-section">
        <div className="container">
          <h2 className="section-title">
            Our <span className="accent-text">Focus Areas</span>
          </h2>
          <div className="title-underline"></div>
          <p className="section-description">
            Specialized programs designed to enhance performance and skill
            development.
          </p>
          <div className="focus-grid">
            <div className="focus-card">
              <img
                src="https://img.freepik.com/free-photo/group-people-working-out-together-outdoors_23-2149891467.jpg?semt=ais_hybrid&w=740&q=80"
                alt="Testing and Evaluation"
                className="focus-image"
              />
              <h3 className="focus-title">Sports Phychologist</h3>
              <p className="focus-description">
                Sports psychologists help athletes strengthen their mindset,
                manage pressure, build confidence, and improve overall
                performance through mental training and focus techniques.{" "}
              </p>
              <Link to="/focus/tests" className="focus-btn">
                LEARN MORE
              </Link>
            </div>
            <div className="focus-card">
              <img
                src="https://askmesportsalliance.com/static/media/meditationImage.261162b4a51e790c9a70.jpeg"
                alt="Leadership Training"
                className="focus-image"
              />
              <h3 className="focus-title">Sports Meditation</h3>
              <p className="focus-description">
                Sports meditation helps athletes calm their minds, improve
                focus, and boost mental strength. It enhances concentration,
                reduces stress, and supports peak performance during training
                and competition.
              </p>
              <Link to="/focus/lead-skill" className="focus-btn">
                LEARN MORE
              </Link>
            </div>
            <div className="focus-card">
              <img
                src="https://static.owayo-cdn.com/newhp/img/magazin/sportnutrition/sport-nutrition-is-perfect-before-during-and-after-exercise_670px.jpg"
                alt="Online Learning"
                className="focus-image"
              />
              <h3 className="focus-title">Sports Nutrition</h3>
              <p className="focus-description">
                Expert sports nutrition guidance and personalized diet plans
                designed to boost performance, enhance recovery, and support
                overall athlete health.{" "}
              </p>
              <Link to="/focus/sports-nutrition" className="focus-btn">
                LEARN MORE
              </Link>
            </div>
            <div className="focus-card">
              <img
                src="https://images.unsplash.com/photo-1603455778956-d71832eafa4e?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGh5c2ljYWwlMjBmaXRuZXNzfGVufDB8fDB8fHww&fm=jpg&q=60&w=3000"
                alt="Online Learning"
                className="focus-image"
              />
              <h3 className="focus-title">Elite Fitness for Athlete </h3>
              <p className="focus-description">
                Elite fitness enhances Strength, Speed, Suppleness & Stamina,
                Elite Fitness develops endurance according to requirements of a
                particular athlete of high level. It helps athletes improve
                performance, prevent injuries, and improve overall performances.{" "}
              </p>
              <Link to="/focus/online-classes" className="focus-btn">
                LEARN MORE
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Our Coaches Section */}
      <section id="coaches" className="coaches-section">
        <div className="container">
          <h2 className="section-title">
            Our <span className="accent-text">Coaches</span>
          </h2>
          <div className="title-underline"></div>
          <p className="section-description">
            Our professional coaching staff brings years of experience and
            expertise to help athletes excel. We believe in personalized
            training approaches that cater to individual strengths and goals.
          </p>
          <div className="coaches-grid">
            {/* <div className="coach-card">
              <img src="./assets/Chitra.jpg" alt="Maria Doe" className="coach-image" />
              <h4 className="coach-name">Chitra</h4>
              <p className="coach-role">CEO and Director</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Praachal.jpg" alt="Elena Rodriguez" className="coach-image" />
              <h4 className="coach-name">Praachal</h4>
              <p className="coach-role">
                Expert and experience in Sports Meditation.</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Mala Sukhwal.jpg" alt="Sarah" className="coach-image" />
              <h4 className="coach-name">Mala Sukhwal</h4>
              <p className="coach-role">Powerlifting</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Hitesh-Deshwal.jpg" alt="John Doe" className="coach-image" />
              <h4 className="coach-name">Hitesh Deshwal</h4>
              <p className="coach-role">Athletics</p>
            </div>
            <div className="coach-card">
              <img src="./assets/akshay-kalosia.jpg" alt="Markes" className="coach-image" />
              <h4 className="coach-name">akshay kalosia</h4>
              <p className="coach-role">Boxing</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Ankit-Kumar-Manawat.jpg" alt="Markes" className="coach-image" />
              <h4 className="coach-name">Ankit Kumar Manawat </h4>
              <p className="coach-role">Squash</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Riyaz-Ahmed.jpg" alt="Markes" className="coach-image" />
              <h4 className="coach-name">Riyaz Ahmed</h4>
              <p className="coach-role">Tennis</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Mohit-Verma.jpg" alt="Markes" className="coach-image" />
              <h4 className="coach-name">Mohit Verma</h4>
              <p className="coach-role">Table Tennis</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Shikha-Dhall.jpg" alt="Markes" className="coach-image" />
              <h4 className="coach-name">Shikha Dhall</h4>
              <p className="coach-role">Rifle Shooting</p>
            </div>
            <div className="coach-card">
              <img src="./assets/Zahir-Taj.jpg" alt="Markes" className="coach-image" />
              <h4 className="coach-name">Zahir Taj</h4>
              <p className="coach-role">Cricket Women</p>
            </div> */}

            {coachesData.map((data, index) => (
              <div
                onClick={() => handleCoachesClick(data.name)}
                key={index}
                className="coach-card"
              >
                <img src={data.image} alt="Markes" className="coach-image" />
                <h4 className="coach-name">{data.name}</h4>
                <p
                  className="coach-role"
                  dangerouslySetInnerHTML={{ __html: data.role }}
                ></p>
              </div>
            ))}
          </div>
          {/* <div className="coaches-navigation">
            <button className="nav-arrow">‹</button>
            <button className="nav-arrow">›</button>
          </div> */}
        </div>
      </section>

      {/* Latest Results Section */}
      {/* <section className="results-section">
        <div className="container">
          <h2 className="section-title">
            Latest <span className="accent-text">Results</span>
          </h2>
          <div className="title-underline"></div>
          <div className="results-grid">
            <div className="result-card">
              <div className="result-header">MON, OCT 21, YOUTH LEAGUE</div>
              <div className="teams-container">
                <div className="team">
                  <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=40&h=40&fit=crop&crop=center" alt="Turkey Team" className="team-logo" />
                  <div className="team-score">3</div>
                  <div className="team-name">Turkey</div>
                </div>
                <div className="vs">VS</div>
                <div className="team">
                  <img src="https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=40&h=40&fit=crop&crop=center" alt="NFL Team" className="team-logo" />
                  <div className="team-score">2</div>
                  <div className="team-name">NFL</div>
                </div>
              </div>
              <button className="result-btn">GAME DETAILS</button>
            </div>
            <div className="result-card">
              <div className="result-header">MON, OCT 21, YOUTH LEAGUE</div>
              <div className="teams-container">
                <div className="team">
                  <img src="https://images.unsplash.com/photo-1546519638-68e109498ffc?w=40&h=40&fit=crop&crop=center" alt="NOL Team" className="team-logo" />
                  <div className="team-score">1</div>
                  <div className="team-name">NOL</div>
                </div>
                <div className="vs">VS</div>
                <div className="team">
                  <img src="https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=40&h=40&fit=crop&crop=center" alt="NFL Team" className="team-logo" />
                  <div className="team-score">0</div>
                  <div className="team-name">NFL</div>
                </div>
              </div>
              <button className="result-btn">GAME DETAILS</button>
            </div>
          </div>
        </div>
      </section> */}

      {/* Sport News Section */}
      <section className="news-section">
        <div className="container">
          <h2 className="section-title">
            Sport <span className="accent-text">News</span>
          </h2>
          <div className="title-underline"></div>
          <p className="section-description">
            Stay updated with the latest sports news, training tips, and
            community events. Our news section keeps you informed about
            everything happening in the sports world.
          </p>
          <div className="news-grid">
            <div className="news-card">
              <img
                src="https://t4.ftcdn.net/jpg/03/08/07/57/360_F_308075782_n2CmkdBKAqF956PUbTKhIg8D2yTws1iW.jpg"
                alt="Sports News"
                className="news-image"
              />
              <div className="news-date">{today}</div>
              <div className="news-content">
                <h3 className="news-title">Badminton</h3>
                <p className="news-excerpt">
                  Advanced badminton coaching and personalized training programs
                  with expert techniques, agility drills, and fitness sessions
                  to enhance speed, precision, and overall performance for
                  professional players.{" "}
                </p>
                <Link
                  to="/news/phasellus-nec-metus-scelerisque"
                  className="news-read-more"
                >
                  READ MORE →
                </Link>
              </div>
            </div>
            <div className="news-card">
              <img
                src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFkbWludG9ufGVufDB8fDB8fHww&fm=jpg&q=60&w=3000"
                alt="Sports News"
                className="news-image"
              />
              <div className="news-date">{today}</div>
              <div className="news-content">
                <h3 className="news-title">NEW TRAINING PROGRAM LAUNCHED</h3>
                <p className="news-excerpt">
                  Advanced coaching techniques and personalized training
                  programs designed to enhance professional athletes’
                  performance through expert guidance, skill development, and
                  targeted training.
                </p>
                <Link
                  to="/news/new-training-program-launched"
                  className="news-read-more"
                >
                  READ MORE →
                </Link>
              </div>
            </div>
            {/* <div className="news-card">
              <img src="https://cdn.prod.website-files.com/632871e15b53a0140af28aeb/671bdf96ac5193b527bd64d8_671aa7d78bbb9fa0e17ae5f1_657387caaba1ba22b89eacf7_Javelin%20Blog%20Images%20(3).jpg" alt="Sports News" className="news-image" />
              <div className="news-date">04 Jan</div>
              <div className="news-content">
                <h3 className="news-title">Vollyball Tranning</h3>
                <p className="news-excerpt">
                  Advanced volleyball coaching and personalized training programs with advanced drills and fitness for professional players.</p>
                <Link to="/news/nullam-placerat-massa-et" className="news-read-more">READ MORE →</Link>
              </div>
            </div> */}
            <div className="news-card">
              <img
                src="https://static.tournamentsoftware.com/Content/images/downloads/tournamentsoftware.png"
                alt="Sports News"
                className="news-image"
              />
              <div className="news-date">{today}</div>
              <div className="news-content">
                <h3 className="news-title">CHAMPIONSHIP RESULTS ANNOUNCED </h3>
                <p className="news-excerpt">
                  Outstanding performances and record-breaking achievements
                  delivered by athletes, showcasing exceptional skill,
                  dedication, and dominance in the latest tournament.{" "}
                </p>
                <a
                  target="_blank"
                  href="https://www.tournamentsoftware.com/"
                  className="news-read-more"
                >
                  READ MORE →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community
                building. Our comprehensive programs help athletes develop both
                physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">
                    Advanced coaching techniques for professional athletes
                  </p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">
                    Outstanding performances in the latest tournament
                  </p>
                </div>
              </div>
              <a href="#" className="view-more">
                View More...
              </a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li>
                  <a href="#" className="footer-link active">
                    HOME
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    ABOUT OUR WEBSITE
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    SHOP
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    GALLERY
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    CONTACT
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">
                  📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur -
                  302019
                </div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">
                  ✉️ askmesportsalliance@gmail.com
                </div>
                <div className="contact-item">
                  🌐 www.askmesportsalliance.com
                </div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img
              src={logo}
              alt="Sports Infrastructure Solutions Logo"
              className="footer-logo-icon footer-icon-image"
            />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping
            Champions.
          </div>
        </div>
      </footer>

      {/* Video Player Modal */}
      {isVideoOpen && (
        <div
          className={`video-modal ${isVideoMinimized ? "minimized" : ""} ${
            isDragging ? "dragging" : ""
          } ${isVideoFullscreen ? "fullscreen" : ""}`}
          style={{
            position: "fixed",
            left: `${videoPosition.x}px`,
            top: `${videoPosition.y}px`,
            transform: "none",
          }}
        >
          <div className="video-header" onMouseDown={handleDragStart}>
            <div className="video-title">Watch Our Video</div>
            <div className="video-controls">
              <button
                className="control-btn fullscreen-btn"
                onClick={toggleFullscreen}
                title={
                  isVideoFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"
                }
              >
                <span>{isVideoFullscreen ? "⤓" : "⤢"}</span>
              </button>
              <button
                className="control-btn minimize-btn"
                onClick={minimizeVideo}
                title="Minimize"
              >
                <span>−</span>
              </button>
              <button
                className="control-btn close-btn"
                onClick={closeVideo}
                title="Close"
              >
                <span>×</span>
              </button>
            </div>
          </div>
          <div className="video-content">
            {isVideoMinimized ? (
              <div className="minimized-video" onClick={maximizeVideo}>
                <div className="play-icon">▶</div>
                <span>Click to maximize</span>
              </div>
            ) : (
              <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/tWU8CXFLOgk?autoplay=1&rel=0&modestbranding=1&enablejsapi=1"
                  title="Sports Alliance Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  onLoad={() => {
                    // Video loaded successfully
                  }}
                  onError={() => {
                    console.warn("Video failed to load");
                  }}
                ></iframe>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
